import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type PinIconProps = Partial<SVGIconProps>;

const PinIcon: FC<PinIconProps> = (props) => (
  <SVGIcon {...props} fill="none" height="24" viewBox="0 0 25 24" width="25">
    <path
      d="M13.0495 4.13005C14.5556 2.62399 16.9969 2.62395 18.503 4.13005C20.0091 5.63615 20.0091 8.0775 18.503 9.5836L11.0793 17.0073C10.1589 17.9277 8.66699 17.9277 7.74658 17.0073C6.82623 16.0869 6.8262 14.595 7.74658 13.6746L14.2614 7.1598C14.5961 6.82527 15.1387 6.82516 15.4733 7.1598C15.8079 7.49445 15.8078 8.03702 15.4733 8.3717L8.95849 14.8865C8.70748 15.1375 8.70752 15.5444 8.95849 15.7954C9.2095 16.0465 9.61639 16.0465 9.86741 15.7954L17.2911 8.3717C18.1278 7.53499 18.1278 6.17867 17.2911 5.34195C16.4544 4.50524 15.0981 4.50528 14.2614 5.34195L6.53468 13.0687C5.11225 14.4911 5.11229 16.7968 6.53468 18.2192C7.95713 19.6417 10.2628 19.6417 11.6853 18.2192L19.412 10.4925C19.7465 10.158 20.2892 10.1582 20.6239 10.4925C20.9586 10.8272 20.9586 11.3706 20.6239 11.7053L12.8972 19.432C10.8054 21.5233 7.41452 21.5233 5.32278 19.432C3.23095 17.3401 3.23095 13.9486 5.32278 11.8568L13.0495 4.13005Z"
      fill="#4B5565"
    />
  </SVGIcon>
);

export default PinIcon;
